import React, { Component } from 'react';

import ProductItem from 'components/ProductItem';
import Slider from 'react-slick';

class CustomSwiper extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		const { data, settings } = this.props;

		return (
			<div className="my-4 my-md-5 swiper productsSwiper">
				<div className="d-flex flex-row align-items-center justify-content-between mx-1 mx-md-2 mb-3 titleSection">
					<h6 className="title m-0">{data.name}</h6>
					{data.products.length > 5 && (
						<button onClick={() => this.props.history.push('/category/someID')}>See All</button>
					)}
				</div>
				<Slider {...settings} className="products">
					{data &&
						data.products &&
						data.products.slice(0, 5).map((item, index) => (
							<div className="slide" key={index}>
								<ProductItem item={item} index={index} />
							</div>
						))}
				</Slider>
			</div>
		);
	}
}
export default CustomSwiper;
